import {AppsyncService} from "../shared/AppsyncService";
import {oktaAuth} from "../config/OktaConfig";
import gql from "graphql-tag";
import {submitManualClearing} from "../../graphql/audit-overview-api/mutations";
import {getBondedQuantitiesByDocumentIds} from "../../graphql/audit-overview-api/queries";

export class ManualClearingService {

    auditOverviewAppsyncService: AppsyncService;

    constructor() {
        this.auditOverviewAppsyncService = new AppsyncService(process.env.REACT_APP_APPSYNC_AUDIT_OVERVIEW_ENDPOINT!, oktaAuth);
    }

    async getBondedQuantitiesByDocumentIds(documentIds: string[]): Promise<any> {
        return this.auditOverviewAppsyncService.appSyncClient.query({
            query: gql(getBondedQuantitiesByDocumentIds),
            variables: {documentIds},
            fetchPolicy: "network-only",
        });
    }

    async submitManualClearing(documentIds: string[], reason: string, comment: string): Promise<any> {
        return this.auditOverviewAppsyncService.appSyncClient.mutate({
            mutation: gql(submitManualClearing),
            variables: {documentIds, reason, comment},
        });
    }
}
